<template>
  <div v-if="loaded && scoreTemplate != null" class="container">
    <div v-if="!HideStudentName" class="row">
      <div class="col">
        <h4 class="modal-title">{{ Student.Name }}</h4>
      </div>
    </div>
    <div class="row mt-4 text-left">
      <div class="col-auto pr-0" v-if="IsArchived">
        <i
          class="material-icons pointer pt-1"
          role="button"
          v-on:click="deleteUnit"
          v-bind:id="'delete' + Student.Student_Id + 'unit' + Unit.Unit_Id"
          @mouseover="
            $showTooltip('#delete' + Student.Student_Id + 'unit' + Unit.Unit_Id)
          "
          @mouseleave="
            $hideTooltip('#delete' + Student.Student_Id + 'unit' + Unit.Unit_Id)
          "
          data-toggle="tooltip"
          data-placement="top"
          title="Delete the student's unit data permanently."
          >delete</i
        >
      </div>
      <div class="col-auto pr-0" v-else>
        <i
          class="material-icons pointer pt-1"
          role="button"
          v-on:click="archiveUnit"
          v-bind:id="'archive' + Student.Student_Id + 'unit' + Unit.Unit_Id"
          @mouseover="
            $showTooltip(
              '#archive' + Student.Student_Id + 'unit' + Unit.Unit_Id
            )
          "
          @mouseleave="
            $hideTooltip(
              '#archive' + Student.Student_Id + 'unit' + Unit.Unit_Id
            )
          "
          data-placement="top"
          title="Archive the student's unit data."
          >archive</i
        >
      </div>
      <h5 class="col text-info mb-0 pt-2">
        <b>{{ unit.Title }}</b>
      </h5>
      <h5 class="col text-info mb-0 pt-2">Scores: {{ scores.length }}</h5>
      <div class="col-auto" v-if="!IsArchived">
        <button class="btn btn-primary mb-1" v-on:click="addScore">
          Add Score
        </button>
      </div>
      <div class="col-auto" v-if="IsArchived">
        <button class="btn btn-primary mb-1" v-on:click="unarchive">
          Unarchive
        </button>
      </div>
    </div>
    <div style="background-color:gray; height:1px; width:100%;" />

    <div
      class="row container"
      v-for="input in scoreTemplate.Score_Template_Inputs.slice().sort(
        $orderByOrder
      )"
      :key="input.Order"
    >
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col-auto pr-0">
                <i
                  class="material-icons float-left pointer mt-0"
                  v-bind:id="
                    'toggleIcon' +
                      input.Order +
                      'scores' +
                      Student.Student_Id +
                      'unit' +
                      Unit.Unit_Id
                  "
                  @mouseover="
                    $showTooltip(
                      '#toggleIcon' +
                        input.Order +
                        'scores' +
                        Student.Student_Id +
                        'unit' +
                        Unit.Unit_Id
                    )
                  "
                  @mouseleave="
                    $hideTooltip(
                      '#toggleIcon' +
                        input.Order +
                        'scores' +
                        Student.Student_Id +
                        'unit' +
                        Unit.Unit_Id
                    )
                  "
                  data-placement="top"
                  title="Show student score details."
                  data-toggle="collapse"
                  v-bind:href="
                    '#details' +
                      input.Order +
                      'scores' +
                      Student.Student_Id +
                      'unit' +
                      Unit.Unit_Id
                  "
                  role="button"
                  aria-expanded="false"
                  v-on:click="
                    $updateToggleIcon(
                      '#toggleIcon' +
                        input.Order +
                        'scores' +
                        Student.Student_Id +
                        'unit' +
                        Unit.Unit_Id
                    )
                  "
                  >add</i
                >
              </div>
              <div class="col-auto">
                <h5 class=" mb-0">{{ input.Request }}</h5>
              </div>
            </div>
          </div>
          <div class="col text-left">
            <div class="row">
              <div class="col-auto">
                <div :key="'graph' + input.Order">
                  <GChart
                    v-if="
                      scores.length > 0 &&
                        parseInt(
                          input.Score_Template_Input_Type_Id
                            ? input.Score_Template_Input_Type_Id
                            : input.Score_Template_Input_Type
                                .Score_Template_Input_Type_Id
                        ) != 6
                    "
                    :id="'graph' + input.Order"
                    :data="getGraphData(input)"
                    :options="getGraphOptions(input, true)"
                    :type="getChartType(input)"
                  />
                </div>
              </div>
              <div class="col-auto">
                <h6
                  class="mb-1"
                  v-if="
                    [1, 2, 3, 8].includes(
                      parseInt(
                        input.Score_Template_Input_Type
                          .Score_Template_Input_Type_Id
                      )
                    ) && scores.length > 0
                  "
                >
                  Average:
                  {{
                    (
                      sum(
                        scores.map(s =>
                          s.Value.find(v => v.order == input.Order)
                        ),
                        "input"
                      ) / scores.length
                    ).toFixed("2")
                  }}
                </h6>
                <div
                  v-for="(score, index) in findLastScore(scores)"
                  :key="index"
                >
                  <h6 v-if="score != null">
                    Last Score:
                    {{
                      $prettifyInput(
                        score.Value.find(i => i.order == input.Order).input,
                        scoreTemplate.Score_Template_Inputs.find(
                          i => i.Order == input.Order
                        )
                      )
                    }}
                    ({{ stringifyDate(score.Date) }})
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="collapse"
          v-bind:id="
            'details' +
              input.Order +
              'scores' +
              Student.Student_Id +
              'unit' +
              Unit.Unit_Id
          "
        >
          <div
            class="my-2"
            style="background-color:gray; height:1px; width:100%;"
          />
          <div class="row text-left mt-1">
            <div class="col-auto" v-if="!IsArchived">
              <i class="material-icons d-block hidden">
                edit
              </i>
            </div>
            <div class="col">
              <h6><b>Title</b></h6>
            </div>
            <div class="col">
              <h6><b>Date</b></h6>
            </div>
            <div class="col">
              <h6><b>Score</b></h6>
            </div>
          </div>

          <div
            class="row text-left mt-2"
            v-for="score in scores.slice().sort($orderByDate)"
            :key="score.ScoreId"
          >
            <div
              class="col-auto"
              v-on:click="editScore(score)"
              v-if="!IsArchived"
            >
              <i class="material-icons d-block pointer">
                edit
              </i>
            </div>
            <div class="col">
              <p class="mb-0">{{ score.Assignment }}</p>
            </div>
            <div class="col">
              <p class="mb-0">
                {{ stringifyDate(score.Date) }}
              </p>
            </div>
            <div class="col">
              <p class="mb-0">
                {{
                  $prettifyInput(
                    score.Value.find(v => v.order == input.Order).input,
                    scoreTemplate.Score_Template_Inputs.find(
                      i => i.Order == input.Order
                    )
                  )
                }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div :key="'graph' + input.Order">
                <GChart
                  v-if="
                    scores.length > 0 &&
                      parseInt(
                        input.Score_Template_Input_Type_Id
                          ? input.Score_Template_Input_Type_Id
                          : input.Score_Template_Input_Type
                              .Score_Template_Input_Type_Id
                      ) != 6
                  "
                  :id="'graph' + input.Order"
                  :data="getGraphData(input)"
                  :options="getGraphOptions(input)"
                  :type="getChartType(input)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="my-2"
        style="background-color:gray; height:1px; width:100%;"
      />
    </div>

    <AddStudentScoreModal
      v-bind:Unit="unit"
      v-bind:Student="Student"
      @added-scores="scoresAdded"
    />
    <EditStudentScoreModal
      v-bind:Unit="unit"
      v-bind:Student="Student"
      v-bind:EditingScore="editingScore"
      @edited-score="scoreEdited"
      @deleted-score="scoreDeleted"
    />
  </div>
</template>

<script>
import $ from "jquery";
import { GChart } from "vue-google-charts";
import AddStudentScoreModal from "@/modals/Student/AddStudentScoreModal.vue";
import EditStudentScoreModal from "@/modals/Student/EditStudentScoreModal.vue";

export default {
  components: {
    GChart,
    AddStudentScoreModal,
    EditStudentScoreModal
  },
  props: {
    ScoreTemplate: Object,
    Scores: Array,
    Unit: Object,
    Student: Object,
    HideStudentName: Boolean,
    IsArchived: Boolean
  },
  data() {
    return {
      unit: this.Unit,
      scores: [],
      editingScore: null,
      charts: [],
      scoreTemplate: JSON.parse(JSON.stringify(this.ScoreTemplate)),
      loaded: false
    };
  },
  watch: {
    Scores: function() {
      this.loadScores();
    },
    Unit: function() {
      this.loadUnit();
    },
    ScoreTemplate: function() {
      this.loadUnit();
    }
  },
  mounted() {
    this.loadUnit();
    this.loadScores();
    this.loaded = true;
  },
  methods: {
    loadScores() {
      this.scores = [];
      this.Scores.forEach(score => {
        var value = [];
        JSON.parse(score.Value).forEach(val => {
          value.push(val);
        });

        this.scores.push({
          Assignment: score.Assignment,
          Date: score.Date,
          Score_Id: score.Score_Id,
          Value: value
        });
      });
    },
    loadUnit() {
      this.scoreTemplate = this.ScoreTemplate;
      var newUnit = this.Unit;
      newUnit.Score_Template = this.ScoreTemplate;
      this.unit = newUnit;
      for (
        let i = 0;
        i < this.scoreTemplate.Score_Template_Inputs.length;
        i++
      ) {
        var parsedInputData = this.$tryParse(
          this.scoreTemplate.Score_Template_Inputs[i].Input_Data
        );
        if (parsedInputData != undefined) {
          this.scoreTemplate.Score_Template_Inputs[
            i
          ].Input_Data = parsedInputData;
        }
      }
    },
    getGraphData(templateInputValue) {
      var scoreArray = [];
      var inputTypeId = parseInt(
        templateInputValue.Score_Template_Input_Type
          .Score_Template_Input_Type_Id
      );
      var responses = [];
      if ([1, 2, 3, 8].includes(inputTypeId)) {
        scoreArray.push(["Date", templateInputValue.Request]);
        this.scores
          .slice()
          .sort(this.$orderByDate)
          .forEach(score => {
            scoreArray.push([
              score.Assignment
                ? score.Assignment
                : this.stringifyDate(score.Date),
              parseFloat(
                score.Value.find(v => v.order == templateInputValue.Order).input
              )
            ]);
          });
      }
      if (inputTypeId == 4) {
        scoreArray.push([templateInputValue.Request, "Data"]);
        responses = this.scores.map(
          s => s.Value.find(v => v.order == templateInputValue.Order).input
        );
        templateInputValue.Input_Data.Choices.forEach(choice => {
          scoreArray.push([
            choice.Choice + " - " + choice.Text,
            responses.filter(r => r == choice.Choice).length
          ]);
        });
      }
      if (inputTypeId == 5 || inputTypeId == 7) {
        scoreArray.push([templateInputValue.Request, "Data"]);
        responses = this.scores.map(
          s => s.Value.find(v => v.order == templateInputValue.Order).input
        );
        scoreArray.push(["Yes", responses.filter(r => r.Occured).length]);
        scoreArray.push(["No", responses.filter(r => !r.Occured).length]);
      }
      return scoreArray;
    },
    getGraphOptions(templateInputValue, small = false) {
      var options = {
        title: templateInputValue.Request,
        legend: { position: "bottom" },
        height: 500,
        chartArea: { width: "80%", height: "80%", top: "30" }
      };
      if (small) {
        options.height = 50;
        options.width = 50;
        options.chartArea.top = 0;
      }

      switch (
        parseInt(
          templateInputValue.Score_Template_Input_Type
            .Score_Template_Input_Type_Id
        )
      ) {
        case 1:
          var outOf = templateInputValue.Input_Data.Out_Of;
          options.vAxis = {
            maxValue: outOf,
            minValue: 0,
            format: "0",
            title: "Score (Out Of " + outOf + ")"
          };
          break;
        case 2:
          options.vAxis = {
            maxValue: 100,
            minValue: 0,
            format: "0",
            title: "Percentage"
          };
          break;
        case 3:
          var maxValue = templateInputValue.Input_Data.Max_Value;
          options.vAxis = {
            maxValue: maxValue,
            minValue: 0,
            format: "0",
            title: "Scale"
          };
          break;
        case 8:
          options.vAxis = {
            minValue: 0,
            format: "0",
            title: "Score"
          };
          break;
      }
      options.trendlines = {
        2: {
          labelInLegend: "Score Trend",
          visibleInLegend: true,
          tooltip: false
        }
      };
      options.series = {
        0: { color: "#1c91c0" },
        1: { color: "#1c91c0" },
        2: { color: "#f1ca3a" }
      };
      return options;
    },
    getChartType(value) {
      switch (value.Score_Template_Input_Type.Score_Template_Input_Type_Id) {
        case "8":
        case "1":
        case "2":
        case "3":
          return "LineChart";
        case "4":
        case "5":
        case "7":
          return "PieChart";
      }
    },
    sum(items, prop) {
      if (items == null) {
        return 0;
      }
      return items.reduce(function(a, b) {
        return b[prop] == null ? a : a + parseFloat(b[prop]);
      }, 0);
    },
    stringifyDate(date) {
      var mdy = date.split("T")[0].split("-");
      return mdy[1] + "/" + mdy[2] + "/" + mdy[0];
    },
    editScore(score) {
      this.editingScore = null;
      this.editingScore = score;
      $(
        "#editStudent" +
          this.Student.Student_Id +
          "Score" +
          this.Unit.Unit_Id +
          "Modal"
      ).modal("show");
    },
    addScore() {
      this.editingScore = null;
      $("#addStudentScoreModal").modal("show");
    },
    scoresAdded(newScore) {
      this.scores.push(newScore);
    },
    scoreEdited(editedScore) {
      var scoreIndex = this.scores.findIndex(
        s => s.Score_Id == editedScore.Score_Id
      );
      this.$set(this.scores, scoreIndex, editedScore);
    },
    scoreDeleted(scoreId) {
      this.scores = this.scores.filter(s => s.Score_Id != scoreId);
    },
    findLastScore(scores) {
      var score = null;
      if (scores.length > 0) {
        score = scores.reduce((a, b) => (a.Date > b.Date ? a : b));
      }
      return [score];
    },
    unarchive() {
      this.$emit("unarchive", this.Unit);
    },
    deleteUnit() {
      this.$emit("delete-unit", this.Unit);
    },
    archiveUnit() {
      this.$hideTooltip(
        "#archive" + this.Student.Student_Id + "unit" + this.Unit.Unit_Id
      );
      this.$emit("archive-unit", this.Unit, this.Student);
    }
  }
};
</script>

<style scoped></style>
